// Module
var code = "<div class=\"md-whiteframe-z1 mn-module flex layout-column\">\n</div>\n";
// Exports
module.exports = code;